import * as React from "react";
function SvgDanmaku(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth={1.3}
      >
        <path d="M3.5 10h13c.55 0 1 .45 1 1v7.9c0 .55-.45 1-1 1H8.48l-2.94 3.03V19.9H3.5c-.55 0-1-.45-1-1V11c0-.55.45-1 1-1z" />
        <path d="M17.52 11.9h6.01l2.94 3.03V11.9h2.03c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1h-13c-.55 0-1 .45-1 1v7.01m0 9.85v6.04c0 .55.45 1 1 1h8.02l2.94 3.03V26.9h2.03c.55 0 1-.45 1-1V18c0-.55-.45-1-1-1H17.48" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDanmaku);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
